<template>
  <div class="md-layout">
    <div class="mktops-maincontent" id="pricinglist">
      <div
        style="position: absolute; top: 50%; left: 52%; width: 10%; z-index: 2"
        v-show="loading == true"
      >
        <md-progress-spinner
          :md-stroke="8"
          :md-diameter="65"
          md-mode="indeterminate"
        ></md-progress-spinner>
        <div v-if="loading" class="bg-overlay-unset" style="z-index: 15"></div>
      </div>

      <div class="md-layout selected-menu">
        <MenuSelected
          ref="menuSelected"
          :selected="selectedMenu"
          @clickmenu="onClickMenu"
        ></MenuSelected>
      </div>

      <div v-show="selectedMenu === 'price'">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-card class="mktops-tab">
              <md-card-content>
                <div style="padding-top: 3px; height: 37px">
                  <div
                    :class="valueTab == 'ALL' ? 'tab-active' : 'tab-in-active'"
                    @click="onClickTab('ALL')"
                    style="margin-left: 20px"
                  >
                    ALL
                    <span class="tab-chip -chipgray">{{ total_all }}</span>
                  </div>
                  <div
                    :class="
                      valueTab == 'UPCOMING' ? 'tab-active' : 'tab-in-active'
                    "
                    @click="onClickTab('UPCOMING')"
                  >
                    UPCOMING
                    <span class="tab-chip -primary">{{ total_upcoming }}</span>
                  </div>
                  <div
                    :class="
                      valueTab == 'WARNING' ? 'tab-active' : 'tab-in-active'
                    "
                    @click="onClickTab('WARNING')"
                  >
                    WARNING
                    <span class="tab-chip -warning">{{ total_warning }}</span>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item" style="width: -webkit-fill-available">
            <md-card class="tab-table">
              <md-card-content>
                <PricingListAll
                  v-if="valueTab != ''"
                  ref="pricingListAll"
                  :valueTab="valueTab"
                  :tbPricingList="tbPricingList"
                  :tbPricingListLog="tbPricingListLog"
                  :total_all_int="total_all_int"
                  :changeTab="changeTab"
                  :filterChips="filterChips"
                  @handleScroll="onHandleScroll"
                  :showChildRows="showChildRows"
                  :loadData="loadData"
                  :dataFilter="dataFilter"
                  @search="onSearch"
                  @count="countPricingList"
                  @filterData="onFilterData"
                  @clearFilter="onclearFilter"
                  :selectedMenu="selectedMenu"
                  :selectedMenuOld="selectedMenuOld"
                ></PricingListAll>
                <PricingDialogFilter
                  v-if="filterdata == true"
                  ref="pricingDialogFilter"
                  :valueTab="valueTab"
                  :vSearch="vSearch"
                  :vFilter="vFilter"
                  :typeAll="typeAll"
                  @clickFilter="onClickFilter"
                  @clickCancel="onClickCancel"
                ></PricingDialogFilter>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>

      <div v-show="selectedMenu === 'bookprice'">
        <TabBookpriceList
          ref="listPage"
          :changeTab="changeTab"
        ></TabBookpriceList>
      </div>
    </div>
  </div>
</template>

<script>
import PricingListAll from "./../pricing/pricing-list-all";
import PricingDialogFilter from "./../pricing/pricing-dialog-filter";
import PricingService from "@/services/pricing";
import MenuSelected from "./../pricing/menu-selected";
import TabBookpriceList from "./../pricing/bookprice/tab-bookprice-list";
import axios from 'axios';

export default {
  name: "pricing-list-page",
  components: {
    PricingListAll: PricingListAll,
    PricingDialogFilter: PricingDialogFilter,
    MenuSelected: MenuSelected,
    TabBookpriceList: TabBookpriceList,
  },
  data() {
    return {
      tbPricingList: [],
      tbPricingListLog: [],
      valueTab: "",
      showChildRows: "",
      search_key: "",
      search_val: "",
      search_type: "",
      search_group: "",
      search_sub_group: "",
      search_cg: "",
      vSearch: "",
      scroll_start: [0],
      tap_val: "",
      total_all_int: 0,
      total_all: "0",
      total_upcoming: "0",
      total_warning: "0",
      loadData: false,
      filterdata: false,
      vFilter: [],
      changeTab: false,
      dataFilter: [],
      filterChips: [],
      typeAll: [],
      selectedMenu: "price",
      selectedMenuOld: "price",
      bookPriceTab: [],
      // changeTab: false
      loading: false,
      cancelTokenSource: null
    };
  },
  created() {
    this.valueTab = "ALL";
    this.tap_val = "ALL";

    this.bookPriceTab = JSON.parse(localStorage.getItem("click_book_price"));
    if (this.bookPriceTab !== null) {
      this.selectedMenu = this.bookPriceTab.tab;
    } else {
      this.countPricingList();
      this.getDataList("");
      this.GetTypeAllProduct();
    }
  },
  watch: {
    selectedMenu() {
      if (this.selectedMenu === "price") {
        this.selectedMenuOld = "bookprice";
        this.changeTab = false;
        this.countPricingList();
        this.getDataList("");
        this.GetTypeAllProduct();
      } else {
        if (this.selectedMenuOld === "price") {
          this.selectedMenuOld = "bookprice";
        } else {
          this.selectedMenuOld = "price";
        }
        this.changeTab = true;
      }
    },
  },
  methods: {
    onClickMenu(menu) {
      this.selectedMenu = menu;
    },
    GetTypeAllProduct() {
      PricingService.GetTypeAllProduct()
        .then((response) => {
          if (response) {
            this.typeAll = response;
          }
        })
        .catch();
    },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        return value;
      } else {
        if (value % 1 == 0) {
          // return true = int
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        } else {
          let parts = value.toString().split(".");
          let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          let digit = parts[1].slice(0, 3);
          digit = digit.length < 2 ? digit + "0" : digit;
          let rs = num + "." + digit;
          let comma = parseFloat(rs.replace(",", ""));
          return Math.round(parseFloat(comma) * 100) / 100;
          // return parts.join(".");
        }
      }
    },
    onFilterData() {
      this.filterdata = true;
    },
    onclearFilter(items) {
      if (items.type == "type") {
        this.vFilter["type"] = [];
        this.vFilter["group"] = [];
        this.vFilter["subGroup"] = [];
        this.vFilter["cg"] = [];

        this.dataFilter["type"] = "";
        this.dataFilter["group"] = "";
        this.dataFilter["subGroup"] = "";
        this.dataFilter["cg"] = "";
      } else if (items.type == "group") {
        this.vFilter["group"] = [];
        this.vFilter["subGroup"] = [];
        this.vFilter["cg"] = [];

        this.dataFilter["group"] = "";
        this.dataFilter["subGroup"] = "";
        this.dataFilter["cg"] = "";
      } else if (items.type == "subGroup") {
        this.vFilter["subGroup"] = [];
        this.vFilter["cg"] = [];

        this.dataFilter["subGroup"] = "";
        this.dataFilter["cg"] = "";
      } else if (items.type == "cg") {
        this.vFilter["cg"] = [];
        this.dataFilter["cg"] = "";
      }
      // this.vFilter[items.type] = [];
      // this.dataFilter[items.type] = "";
      this.dataFilter["keyword"] = this.vSearch.keyword;
      this.scroll_start = [0];
      this.getDataList(this.dataFilter);
    },
    async getDataList(dataSearch) {
      // ยกเลิก request ก่อนหน้าถ้ามี
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Operation canceled due to new request.');
      }
      // สร้าง cancel token ใหม่
      this.cancelTokenSource = axios.CancelToken.source();

      try {
        let warningSearch = dataSearch.optWarning || 0;
        let emp_code = this.$jwt.decode(localStorage.getItem("token")).code;
        if (dataSearch == "") {
          dataSearch = {};
        }
        dataSearch.emp_code = emp_code;

        this.loading = true;
        await PricingService.getPriceList(this.valueTab, dataSearch, null, this.cancelTokenSource.token)
          .then((response) => {
            let pricing_arr = [];
            if (response.length > 0) {
              for (let i = 0; i < response.length; i++) {
                if (warningSearch !== 0) {
                  if (response[i]["msg_warning_" + warningSearch] === "") {
                    continue;
                  }
                }
                let pricing_obj = {};
                let res = response[i];

                let percent_c3 = 0;
                let percent_c2 = 0;
                let percent_c1 = 0;
                let percent_c0 = 0;
                let percent_sr = 0;
                let percent_ss = 0;
                let percent_b2 = 0;
                let percent_b1 = 0;
                let percent_a1 = 0;
                let percent_a2 = 0;
                let percent_a3 = 0;

                if (res.price != undefined) {
                  let temp = "";
                  res.price.A2 =
                    typeof res.price.A2 == "undefined" ? temp : res.price.A2;
                  res.price.A1 =
                    typeof res.price.A1 == "undefined" ? temp : res.price.A1;
                  res.price.C3 =
                    typeof res.price.C3 == "undefined" ? temp : res.price.C3;
                  res.price.C2 =
                    typeof res.price.C2 == "undefined" ? temp : res.price.C2;
                  res.price.C1 =
                    typeof res.price.C1 == "undefined" ? temp : res.price.C1;
                  res.price.C0 =
                    typeof res.price.C0 == "undefined" ? temp : res.price.C0;
                  res.price.SR =
                    typeof res.price.SR == "undefined" ? temp : res.price.SR;
                  res.price.SS =
                    typeof res.price.SS == "undefined" ? temp : res.price.SS;
                  res.price["B2-MT"] =
                    typeof res.price["B2-MT"] == "undefined"
                      ? temp
                      : res.price["B2-MT"];
                  res.price["B1-MT"] =
                    typeof res.price["B1-MT"] == "undefined"
                      ? temp
                      : res.price["B1-MT"];
                }

                //-------------------

                // percent_c3 =
                //     ((parseFloat(res.price.C3) - parseFloat(res.price.A3)) /
                //         parseFloat(res.price.A3)) *
                //     100;
                // percent_c2 =
                //     ((parseFloat(res.price.C2) - parseFloat(res.price.A3)) /
                //         parseFloat(res.price.A3)) *
                //     100;
                // percent_c1 =
                //     ((parseFloat(res.price.C1) - parseFloat(res.price.A3)) /
                //         parseFloat(res.price.A3)) *
                //     100;
                // percent_c0 =
                //     ((parseFloat(res.price.C0) - parseFloat(res.price.A3)) /
                //         parseFloat(res.price.A3)) *
                //     100;
                // percent_b1 =
                //     ((parseFloat(res.price['B1-MT']) - parseFloat(res.price.A3)) /
                //         parseFloat(res.price.A3)) *
                //     100;
                // percent_b2 =
                //     ((parseFloat(res.price['B2-MT']) - parseFloat(res.price.A3)) /
                //         parseFloat(res.price.A3)) *
                //     100;

                // if (res.selling_conv_price != undefined) {
                //   let temp_conv = "";
                //   res.selling_conv_price.A2 =
                //     typeof res.selling_conv_price.A2 == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.A2;
                //   res.selling_conv_price.A1 =
                //     typeof res.selling_conv_price.A1 == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.A1;
                //   res.selling_conv_price.C3 =
                //     typeof res.selling_conv_price.C3 == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.C3;
                //   res.selling_conv_price.C2 =
                //     typeof res.selling_conv_price.C2 == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.C2;
                //   res.selling_conv_price.C1 =
                //     typeof res.selling_conv_price.C1 == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.C1;
                //   res.selling_conv_price.C0 =
                //     typeof res.selling_conv_price.C0 == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.C0;
                //   res.selling_conv_price["B2-MT"] =
                //     typeof res.selling_conv_price["B2-MT"] == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price["B2-MT"];
                //   res.selling_conv_price["B1-MT"] =
                //     typeof res.selling_conv_price["B1-MT"] == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price["B1-MT"];
                //   res.selling_conv_price.SR =
                //     typeof res.selling_conv_price.SR == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.SR;
                //   res.selling_conv_price.SS =
                //     typeof res.selling_conv_price.SS == "undefined"
                //       ? temp_conv
                //       : res.selling_conv_price.SS;
                // }

                let effective_date = "";
                let mtime = "";
                if (
                  res.effective_date &&
                  res.effective_date != "" &&
                  res.effective_date != null &&
                  res.effective_date != " "
                  // res.effective_date_next &&
                  // res.effective_date_next != "" &&
                  // res.effective_date_next != null &&
                  // res.effective_date_next != " "
                ) {
                  let res_effective_date = new Date(res.effective_date);
                  // let res_effective_date = new Date(res.effective_date_next);
                  let year_eff = res_effective_date.getFullYear();
                  let month_eff =
                    (res_effective_date.getMonth() < 9 ? "0" : "") +
                    (res_effective_date.getMonth() + 1);
                  let date_eff =
                    (res_effective_date.getDate() < 10 ? "0" : "") +
                    res_effective_date.getDate();
                  effective_date = date_eff + "-" + month_eff + "-" + year_eff;
                }

                if (res.mtime != "" && res.mtime != null && res.mtime != " ") {
                  let res_mtime = new Date(res.mtime);
                  let year_mtime = res_mtime.getFullYear();
                  let month_mtime =
                    (res_mtime.getMonth() < 9 ? "0" : "") +
                    (res_mtime.getMonth() + 1);
                  let date_mtime =
                    (res_mtime.getDate() < 10 ? "0" : "") + res_mtime.getDate();
                  mtime = date_mtime + "-" + month_mtime + "-" + year_mtime;
                }

                let warning = "";
                if (res.msg_warning_1 != "") {
                  warning = res.msg_warning_1;
                } else if (res.msg_warning_2 != "") {
                  warning = res.msg_warning_2;
                } else if (res.msg_warning_3 != "") {
                  warning = res.msg_warning_3;
                } else if (res.msg_warning_4 != "") {
                  warning = res.msg_warning_4;
                } else if (res.msg_warning_5 != "") {
                  warning = res.msg_warning_5;
                } else if (res.msg_warning_6 != "") {
                  warning = res.msg_warning_6;
                } else if (res.msg_warning_7 != "") {
                  warning = res.msg_warning_7;
                }

                //                            console.info('res.have_log', res.have_log);
                if (this.valueTab === "ALL" || this.valueTab === "WARNING") {
                  if (res.selling_conv_price != undefined) {
                    let temp_conv = "";
                    res.selling_conv_price.A3 =
                      typeof res.selling_conv_price.A3 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.A3;
                    res.selling_conv_price.A2 =
                      typeof res.selling_conv_price.A2 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.A2;
                    res.selling_conv_price.A1 =
                      typeof res.selling_conv_price.A1 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.A1;
                    res.selling_conv_price.C3 =
                      typeof res.selling_conv_price.C3 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.C3;
                    res.selling_conv_price.C2 =
                      typeof res.selling_conv_price.C2 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.C2;
                    res.selling_conv_price.C1 =
                      typeof res.selling_conv_price.C1 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.C1;
                    res.selling_conv_price.C0 =
                      typeof res.selling_conv_price.C0 == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.C0;
                    res.selling_conv_price["B2-MT"] =
                      typeof res.selling_conv_price["B2-MT"] == "undefined"
                        ? temp_conv
                        : res.selling_conv_price["B2-MT"];
                    res.selling_conv_price["B1-MT"] =
                      typeof res.selling_conv_price["B1-MT"] == "undefined"
                        ? temp_conv
                        : res.selling_conv_price["B1-MT"];
                    res.selling_conv_price.SR =
                      typeof res.selling_conv_price.SR == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.SR;
                    res.selling_conv_price.SS =
                      typeof res.selling_conv_price.SS == "undefined"
                        ? temp_conv
                        : res.selling_conv_price.SS;

                    let v_a3 =
                      res.selling_conv_price.A3 === "" ||
                      parseFloat(res.selling_conv_price.A3) === 0
                        ? 0
                        : parseFloat(res.selling_conv_price.A3);
                    let percent_selling_conv_price_a3 =
                      res.selling_conv_price.A3 === ""
                        ? ""
                        : res.selling_conv_price.A3;
                    let percent_selling_conv_price_C3 =
                      res.selling_conv_price.C3 === ""
                        ? ""
                        : res.selling_conv_price.C3;
                    let percent_selling_conv_price_C2 =
                      res.selling_conv_price.C2 === ""
                        ? ""
                        : res.selling_conv_price.C2;
                    let percent_selling_conv_price_C1 =
                      res.selling_conv_price.C1 === ""
                        ? ""
                        : res.selling_conv_price.C1;
                    let percent_selling_conv_price_C0 =
                      res.selling_conv_price.C0 === ""
                        ? ""
                        : res.selling_conv_price.C0;
                    let percent_selling_conv_price_B1MT =
                      res.selling_conv_price["B1-MT"] === ""
                        ? ""
                        : res.selling_conv_price["B1-MT"];
                    let percent_selling_conv_price_B2MT =
                      res.selling_conv_price["B2-MT"] === ""
                        ? ""
                        : res.selling_conv_price["B2-MT"];
                    let percent_selling_conv_price_SR =
                      res.selling_conv_price.SR === ""
                        ? ""
                        : res.selling_conv_price.SR;
                    let percent_selling_conv_price_SS =
                      res.selling_conv_price.SS === ""
                        ? ""
                        : res.selling_conv_price.SS;
                    let percent_selling_conv_price_A2 =
                      res.selling_conv_price.A2 === ""
                        ? ""
                        : res.selling_conv_price.A2;
                    let percent_selling_conv_price_A1 =
                      res.selling_conv_price.A1 === ""
                        ? ""
                        : res.selling_conv_price.A1;
                    if (v_a3 === 0) {
                      percent_a3 = 0;
                      percent_c3 = 0;
                      percent_c2 = 0;
                      percent_c1 = 0;
                      percent_c0 = 0;
                      percent_b1 = 0;
                      percent_b2 = 0;
                      percent_sr = 0;
                      percent_ss = 0;
                    } else {
                      percent_a3 =
                        percent_selling_conv_price_a3 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_a3) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_c3 =
                        percent_selling_conv_price_C3 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_C3) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_c2 =
                        percent_selling_conv_price_C2 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_C2) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_c1 =
                        percent_selling_conv_price_C1 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_C1) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_c0 =
                        percent_selling_conv_price_C0 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_C0) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_b1 =
                        percent_selling_conv_price_B1MT === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_B1MT) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_b2 =
                        percent_selling_conv_price_B2MT === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_B2MT) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_sr =
                        percent_selling_conv_price_SR === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_SR) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                      percent_ss =
                        percent_selling_conv_price_SS === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_SS) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_a3)) *
                            100;
                    }

                    let v_a2 =
                      parseFloat(percent_selling_conv_price_A2) === 0
                        ? 0
                        : parseFloat(percent_selling_conv_price_A2);
                    if (v_a2 === 0) {
                      percent_a2 = 0;
                    } else {
                      percent_a2 =
                        percent_selling_conv_price_A2 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_A2) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_A2)) *
                            100;
                    }

                    let v_a1 =
                      parseFloat(percent_selling_conv_price_A1) === 0
                        ? 0
                        : parseFloat(percent_selling_conv_price_A1);
                    if (v_a1 === 0) {
                      percent_a1 = 0;
                    } else {
                      percent_a1 =
                        percent_selling_conv_price_A1 === ""
                          ? 0
                          : ((parseFloat(percent_selling_conv_price_A1) -
                              parseFloat(percent_selling_conv_price_a3)) /
                              parseFloat(percent_selling_conv_price_A1)) *
                            100;
                    }
                  }

                  pricing_obj = {
                    stock_um_title: res.stock_um_title,
                    selling_um_title: res.selling_um_title,
                    selling_um_conv: res.selling_um_conv,
                    iprod: res.code,
                    cost: res.cost ? this.formatNumber(res.cost, 2) : "",
                    cost_conv: res.cost_conv
                      ? this.formatNumber(res.cost_conv, 2)
                      : "",
                    title_th: res.title_th,
                    productcg_code: res.productgroup_code,
                    saleprice_um_title: res.stock_um_title,
                    price: {
                      price_a3:
                        res.price && res.price.A3 != undefined
                          ? this.formatNumber(res.price.A3, 2)
                          : "",
                      price_a2:
                        res.price && res.price.A2 != undefined
                          ? this.formatNumber(res.price.A2, 2)
                          : "",
                      price_a1:
                        res.price && res.price.A1 != undefined
                          ? this.formatNumber(res.price.A1, 2)
                          : "",
                      price_c3:
                        res.price && res.price.C3 != undefined
                          ? this.formatNumber(res.price.C3, 2)
                          : "",
                      price_c2:
                        res.price && res.price.C2 != undefined
                          ? this.formatNumber(res.price.C2, 2)
                          : "",
                      price_c1:
                        res.price && res.price.C1 != undefined
                          ? this.formatNumber(res.price.C1, 2)
                          : "",
                      price_c0:
                        res.price && res.price.C0 != undefined
                          ? this.formatNumber(res.price.C0, 2)
                          : "",
                      price_b1:
                        res.price && res.price["B1-MT"] != undefined
                          ? this.formatNumber(res.price["B1-MT"], 2)
                          : "",
                      price_b2:
                        res.price && res.price["B2-MT"] != undefined
                          ? this.formatNumber(res.price["B2-MT"], 2)
                          : "",
                      price_sr:
                        res.price && res.price.SR != undefined
                          ? this.formatNumber(res.price.SR, 2)
                          : "",
                      price_ss:
                        res.price && res.price.SS != undefined
                          ? this.formatNumber(res.price.SS, 2)
                          : "",
                    },
                    selling_conv_price: {
                      selling_conv_price_a3:
                        res.selling_conv_price &&
                        res.selling_conv_price.A3 != undefined
                          ? this.formatNumber(res.selling_conv_price.A3, 2)
                          : "",
                      selling_conv_price_a2:
                        res.selling_conv_price &&
                        res.selling_conv_price.A2 != undefined
                          ? this.formatNumber(res.selling_conv_price.A2, 2)
                          : "",
                      selling_conv_price_a1:
                        res.selling_conv_price &&
                        res.selling_conv_price.A1 != undefined
                          ? this.formatNumber(res.selling_conv_price.A1, 2)
                          : "",
                      selling_conv_price_c3:
                        res.selling_conv_price &&
                        res.selling_conv_price.C3 != undefined
                          ? this.formatNumber(res.selling_conv_price.C3, 2)
                          : "",
                      selling_conv_price_c2:
                        res.selling_conv_price &&
                        res.selling_conv_price.C2 != undefined
                          ? this.formatNumber(res.selling_conv_price.C2, 2)
                          : "",
                      selling_conv_price_c1:
                        res.selling_conv_price &&
                        res.selling_conv_price.C1 != undefined
                          ? this.formatNumber(res.selling_conv_price.C1, 2)
                          : "",
                      selling_conv_price_c0:
                        res.selling_conv_price &&
                        res.selling_conv_price.C0 != undefined
                          ? this.formatNumber(res.selling_conv_price.C0, 2)
                          : "",
                      selling_conv_price_b1:
                        res.selling_conv_price &&
                        res.selling_conv_price["B1-MT"] != undefined
                          ? this.formatNumber(res.selling_conv_price["B1-MT"], 2)
                          : "",
                      selling_conv_price_b2:
                        res.selling_conv_price &&
                        res.selling_conv_price["B2-MT"] != undefined
                          ? this.formatNumber(res.selling_conv_price["B2-MT"], 2)
                          : "",
                      selling_conv_price_sr:
                        res.selling_conv_price &&
                        res.selling_conv_price.SR != undefined
                          ? this.formatNumber(res.selling_conv_price.SR, 2)
                          : "",
                      selling_conv_price_ss:
                        res.selling_conv_price &&
                        res.selling_conv_price.SS != undefined
                          ? this.formatNumber(res.selling_conv_price.SS, 2)
                          : "",
                    },

                    mtime: mtime,
                    effective_date: effective_date,
                    percent: {
                      percent_a3: percent_a3 ? percent_a3 : "0",
                      percent_a2: percent_a2 ? percent_a2 : "0",
                      percent_a1: percent_a1 ? percent_a1 : "0",
                      percent_c3: percent_c3 ? percent_c3 : "0",
                      percent_c2: percent_c2 ? percent_c2 : "0",
                      percent_c1: percent_c1 ? percent_c1 : "0",
                      percent_c0: percent_c0 ? percent_c0 : "0",
                      percent_b1: percent_b1 ? percent_b1 : "0",
                      percent_b2: percent_b2 ? percent_b2 : "0",
                      percent_sr: percent_sr ? percent_sr : "0",
                      percent_ss: percent_ss ? percent_ss : "0",
                    },
                    //have_log: (res.have_log.length > 0) ? 1 : 0,
                    have_log: res.have_log === undefined ? 0 : 1,
                    data_log: {},
                    warning,
                  };
                } else {
                  // if (res.price_conv != undefined) {
                  //   let temp_conv = "";
                  //   res.price_conv.A3 =
                  //     typeof res.price_conv.A3 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.A3;
                  //   res.price_conv.A2 =
                  //     typeof res.price_conv.A2 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.A2;
                  //   res.price_conv.A1 =
                  //     typeof res.price_conv.A1 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.A1;
                  //   res.price_conv.C3 =
                  //     typeof res.price_conv.C3 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.C3;
                  //   res.price_conv.C2 =
                  //     typeof res.price_conv.C2 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.C2;
                  //   res.price_conv.C1 =
                  //     typeof res.price_conv.C1 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.C1;
                  //   res.price_conv.C0 =
                  //     typeof res.price_conv.C0 == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.C0;
                  //   res.price_conv["B2-MT"] =
                  //     typeof res.price_conv["B2-MT"] == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv["B2-MT"];
                  //   res.price_conv["B1-MT"] =
                  //     typeof res.price_conv["B1-MT"] == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv["B1-MT"];
                  //   res.price_conv.SR =
                  //     typeof res.price_conv.SR == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.SR;
                  //   res.price_conv.SS =
                  //     typeof res.price_conv.SS == "undefined"
                  //       ? temp_conv
                  //       : res.price_conv.SS;

                  //   let v_a3 = (res.price_conv.A3 === "" || parseFloat(res.price_conv.A3) === 0) ? 0 : parseFloat(res.price_conv.A3);
                  //   let percent_price_conv_a3 = (res.price_conv.A3 === "") ? "" : res.price_conv.A3;
                  //   let percent_price_conv_C3 = (res.price_conv.C3 === "") ? "" : res.price_conv.C3;
                  //   let percent_price_conv_C2 = (res.price_conv.C2 === "") ? "" : res.price_conv.C2;
                  //   let percent_price_conv_C1 = (res.price_conv.C1 === "") ? "" : res.price_conv.C1;
                  //   let percent_price_conv_C0 = (res.price_conv.C0 === "") ? "" : res.price_conv.C0;
                  //   let percent_price_conv_B1MT = (res.price_conv['B1-MT'] === "") ? "" : res.price_conv['B1-MT'];
                  //   let percent_price_conv_B2MT = (res.price_conv['B2-MT'] === "") ? "" : res.price_conv['B2-MT'];
                  //   let percent_price_conv_SR = (res.price_conv.SR === "") ? "" : res.price_conv.SR;
                  //   let percent_price_conv_SS = (res.price_conv.SS === "") ? "" : res.price_conv.SS;
                  //   let percent_price_conv_A2 = (res.price_conv.A2 === "") ? "" : res.price_conv.A2;
                  //   let percent_price_conv_A1 = (res.price_conv.A1 === "") ? "" : res.price_conv.A1;
                  //   if(v_a3 === 0) {
                  //       percent_a3 = 0
                  //       percent_c3 = 0
                  //       percent_c2 = 0
                  //       percent_c1 = 0
                  //       percent_c0 = 0
                  //       percent_b1 = 0
                  //       percent_b2 = 0
                  //       percent_sr = 0
                  //       percent_ss = 0
                  //   } else {
                  //       percent_a3 = (percent_price_conv_a3 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_a3) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_c3 = (percent_price_conv_C3 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_C3) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_c2 = (percent_price_conv_C2 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_C2) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_c1 = (percent_price_conv_C1 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_C1) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_c0 = (percent_price_conv_C0 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_C0) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_b1 = (percent_price_conv_B1MT === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_B1MT) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_b2 = (percent_price_conv_B2MT === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_B2MT) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_sr = (percent_price_conv_SR === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_SR) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //       percent_ss = (percent_price_conv_SS === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_SS) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_a3)) *
                  //           100;
                  //   }

                  //   let v_a2 = (parseFloat(percent_price_conv_A2) === 0) ? 0 : parseFloat(percent_price_conv_A2);
                  //   if(v_a2 === 0) {
                  //       percent_a2 = 0
                  //   } else {
                  //       percent_a2 = (percent_price_conv_A2 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_A2) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_A2)) *
                  //           100;
                  //   }

                  //   let v_a1 = (parseFloat(percent_price_conv_A1) === 0) ? 0 : parseFloat(percent_price_conv_A1);
                  //   if(v_a1 === 0) {
                  //       percent_a1 = 0
                  //   } else {
                  //       percent_a1 = (percent_price_conv_A1 === "") ? 0 :
                  //           ((parseFloat(percent_price_conv_A1) - parseFloat(percent_price_conv_a3)) /
                  //               parseFloat(percent_price_conv_A1)) *
                  //           100;
                  //   }
                  // }

                  pricing_obj = {
                    stock_um_title: res.product.stock_um_title,
                    selling_um_title: res.product.selling_um_title,
                    selling_um_conv: res.product.selling_um_conv,
                    iprod: res.iprod,
                    cost: res.cost ? this.formatNumber(res.cost, 2) : "",
                    cost_conv: res.cost_conv
                      ? this.formatNumber(res.cost_conv, 2)
                      : "",
                    title_th: res.product.title_th,
                    productcg_code: res.product.productgroup_code,
                    saleprice_um_title: res.product.stock_um_title,
                    price: {
                      price_a3:
                        res.price && res.price.A3 != undefined
                          ? this.formatNumber(res.price.A3, 2)
                          : "",
                      price_a2:
                        res.price && res.price.A2 != undefined
                          ? this.formatNumber(res.price.A2, 2)
                          : "",
                      price_a1:
                        res.price && res.price.A1 != undefined
                          ? this.formatNumber(res.price.A1, 2)
                          : "",
                      price_c3:
                        res.price && res.price.C3 != undefined
                          ? this.formatNumber(res.price.C3, 2)
                          : "",
                      price_c2:
                        res.price && res.price.C2 != undefined
                          ? this.formatNumber(res.price.C2, 2)
                          : "",
                      price_c1:
                        res.price && res.price.C1 != undefined
                          ? this.formatNumber(res.price.C1, 2)
                          : "",
                      price_c0:
                        res.price && res.price.C0 != undefined
                          ? this.formatNumber(res.price.C0, 2)
                          : "",
                      price_b1:
                        res.price && res.price["B1-MT"] != undefined
                          ? this.formatNumber(res.price["B1-MT"], 2)
                          : "",
                      price_b2:
                        res.price && res.price["B2-MT"] != undefined
                          ? this.formatNumber(res.price["B2-MT"], 2)
                          : "",
                      price_sr:
                        res.price && res.price.SR != undefined
                          ? this.formatNumber(res.price.SR, 2)
                          : "",
                      price_ss:
                        res.price && res.price.SS != undefined
                          ? this.formatNumber(res.price.SS, 2)
                          : "",
                    },
                    selling_conv_price: {
                      selling_conv_price_a3:
                        res.price_conv && res.price_conv.A3 != undefined
                          ? this.formatNumber(res.price_conv.A3, 2)
                          : "",
                      selling_conv_price_a2:
                        res.price_conv && res.price_conv.A2 != undefined
                          ? this.formatNumber(res.price_conv.A2, 2)
                          : "",
                      selling_conv_price_a1:
                        res.price_conv && res.price_conv.A1 != undefined
                          ? this.formatNumber(res.price_conv.A1, 2)
                          : "",
                      selling_conv_price_c3:
                        res.price_conv && res.price_conv.C3 != undefined
                          ? this.formatNumber(res.price_conv.C3, 2)
                          : "",
                      selling_conv_price_c2:
                        res.price_conv && res.price_conv.C2 != undefined
                          ? this.formatNumber(res.price_conv.C2, 2)
                          : "",
                      selling_conv_price_c1:
                        res.price_conv && res.price_conv.C1 != undefined
                          ? this.formatNumber(res.price_conv.C1, 2)
                          : "",
                      selling_conv_price_c0:
                        res.price_conv && res.price_conv.C0 != undefined
                          ? this.formatNumber(res.price_conv.C0, 2)
                          : "",
                      selling_conv_price_b1:
                        res.price_conv && res.price_conv["B1-MT"] != undefined
                          ? this.formatNumber(res.price_conv["B1-MT"], 2)
                          : "",
                      selling_conv_price_b2:
                        res.price_conv && res.price_conv["B2-MT"] != undefined
                          ? this.formatNumber(res.price_conv["B2-MT"], 2)
                          : "",
                      selling_conv_price_sr:
                        res.price_conv && res.price_conv.SR != undefined
                          ? this.formatNumber(res.price_conv.SR, 2)
                          : "",
                      selling_conv_price_ss:
                        res.price_conv && res.price_conv.SS != undefined
                          ? this.formatNumber(res.price_conv.SS, 2)
                          : "",
                    },
                    mtime: mtime,
                    effective_date: effective_date,
                    percent: {
                      percent_a3: percent_a3 ? percent_a3 : "0",
                      percent_a2: percent_a2 ? percent_a2 : "0",
                      percent_a1: percent_a1 ? percent_a1 : "0",
                      percent_c3: percent_c3 ? percent_c3 : "0",
                      percent_c2: percent_c2 ? percent_c2 : "0",
                      percent_c1: percent_c1 ? percent_c1 : "0",
                      percent_c0: percent_c0 ? percent_c0 : "0",
                      percent_b1: percent_b1 ? percent_b1 : "0",
                      percent_b2: percent_b2 ? percent_b2 : "0",
                      percent_sr: percent_sr ? percent_sr : "0",
                      percent_ss: percent_ss ? percent_ss : "0",
                    },
                    have_log: res.have_log.length > 0 ? 1 : 0,
                    data_log: {},
                    warning,
                  };
                }

                pricing_arr.push(pricing_obj);

                if (
                  // this.search_key == dataSearch.search &&
                  this.search_val == dataSearch.keyword &&
                  this.search_type == dataSearch.type &&
                  this.search_group == dataSearch.group &&
                  this.search_sub_group == dataSearch.subGroup &&
                  this.search_cg == dataSearch.cg &&
                  this.valueTab == this.tap_val &&
                  dataSearch.start > 0
                ) {
                  //infinity scroll
                  // console.log("infinity scroll");
                  this.tbPricingList.push(pricing_obj);
                } else if (dataSearch.start == 0) {
                  //filter search ตัวเดิม
                  // console.log("filter search ตัวเดิม");
                  this.tbPricingList = pricing_arr;
                }
              }
              if (
                // this.search_key != dataSearch.search ||
                this.search_val != dataSearch.keyword ||
                this.search_type != dataSearch.type ||
                this.search_group != dataSearch.group ||
                this.search_sub_group != dataSearch.subGroup ||
                this.search_cg != dataSearch.cg ||
                this.valueTab != this.tap_val
              ) {
                // console.log("==>");
                //มีการ search ค่าใหม่ หรือ ถ้ามีการเปลี่ยน tab
                this.tap_val = this.valueTab;
                this.search_key = dataSearch.search;
                this.search_val = dataSearch.keyword;
                this.search_type = dataSearch.type;
                this.search_group = dataSearch.group;
                this.search_sub_group = dataSearch.subGroup;
                this.search_cg = dataSearch.cg;
                this.tbPricingList = pricing_arr;
              }
            } else {
              if (
                // this.search_key != dataSearch.search ||
                this.search_val != dataSearch.keyword ||
                this.search_type != dataSearch.type ||
                this.search_group != dataSearch.group ||
                this.search_sub_group != dataSearch.subGroup ||
                this.search_cg != dataSearch.cg ||
                this.valueTab != this.tap_val
              ) {
                this.tap_val = this.valueTab;
                this.search_key = dataSearch.search;
                this.search_val = dataSearch.keyword;
                this.search_type = dataSearch.type;
                this.search_group = dataSearch.group;
                this.search_sub_group = dataSearch.subGroup;
                this.search_cg = dataSearch.cg;
                this.tbPricingList = [];
              }
            }

            this.loadData = false;
            this.loading = false;
          })
          .catch();
        } catch (error) {
          if (axios.isCancel(error)) {
            // console.log('Previous request canceled');
          } else {
            // handle error
            console.error(error);
          }
        }
    },
    onClickTab(vTab) {
      // this.loadData = true;
      let dataSearch = [];
      this.scroll_start = [0];
      this.tbPricingList = [];
      this.valueTab = vTab;
      this.search_key = this.vSearch.search;
      this.search_val = this.vSearch.keyword;
      this.changeTab = this.changeTab == false ? true : false;

      let setValue = this.vSearch.search;
      if (this.vSearch === null || this.vSearch === "") {
        setValue = "code";
      }

      dataSearch = {
        search: setValue,
        keyword: this.vSearch.keyword,
        type: this.search_type,
        group: this.search_group,
        subGroup: this.search_sub_group,
        cg: this.search_cg,
      };
      this.getDataList(dataSearch);
    },
    onHandleScroll(dataScroll) {
      // this.loadData = true;
      let dataSearch = [];
      if (!this.scroll_start.includes(dataScroll.start)) {
        this.scroll_start.push(dataScroll.start);
        dataSearch = {
          search: this.vSearch.search,
          keyword: this.vSearch.keyword,
          type: this.search_type,
          group: this.search_group,
          subGroup: this.search_sub_group,
          cg: this.search_cg,
          start: dataScroll.start,
          limit: dataScroll.length,
        };
        this.getDataList(dataSearch);
      } else {
        this.loadData = false;
      }
    },
    onSearch(search) {
      // this.loadData = true;
      this.scroll_start = [0];
      this.tbPricingList = [];
      this.vSearch = search;
      this.getDataList(search);
    },
    countPricingList() {
      // this.loadData = true;
      PricingService.countPricingList()
        .then((response) => {
          // console.log(response.count_all);
          if (response) {
            this.total_all_int = response.count_all;
            this.total_all = this.formatNumber(response.count_all, 0);
            this.total_warning = this.formatNumber(response.count_warning, 0);
            this.total_upcoming = this.formatNumber(response.count_upcoming, 0);
          }
          this.loadData = false;
        })
        .catch();
    },
    onClickFilter(dataSearch, setArrFilter) {
      this.scroll_start = [];
      this.changeTab = this.changeTab == false ? true : false;
      // this.loadData = true;
      this.vFilter = setArrFilter;
      this.dataFilter = [];
      this.dataFilter = dataSearch;
      this.getDataList(dataSearch);
      this.filterdata = false;

      this.filterChips = [];
      for (let i = 0; i < 4; i++) {
        let obj = {};
        if (i == 0) {
          if (setArrFilter.type.id !== undefined) {
            obj = {
              name: setArrFilter.type.label,
              id: setArrFilter.type.id,
              type: "type",
            };
          }
        } else if (i == 1) {
          if (setArrFilter.group.id !== undefined) {
            obj = {
              name: setArrFilter.group.label,
              id: setArrFilter.group.id,
              type: "group",
            };
          }
        } else if (i == 2) {
          if (setArrFilter.subGroup.id !== undefined) {
            obj = {
              name: setArrFilter.subGroup.label,
              id: setArrFilter.subGroup.id,
              type: "subGroup",
            };
          }
        } else {
          if (setArrFilter.cg.id !== undefined) {
            obj = {
              name: setArrFilter.cg.label,
              id: setArrFilter.cg.id,
              type: "cg",
            };
          }
        }

        if (obj.id !== undefined) {
          this.filterChips.push(obj);
        }
      }
    },
    onClickCancel() {
      this.filterdata = false;
    },
  },
};
</script>

<style lang="scss">
#pricinglist {
  width: 100%;
  padding: 0 !important;

  .selected-menu {
    background: white;

    .md-layout-item {
      margin: 10px 15px 0px;

      .md-button {
        font-family: lato;
        font-size: 14px;
        border-radius: 3px;

        &.-default {
          background: #bebfbf;
        }

        .md-button-content {
          margin: 0px 50px;
        }
      }
    }
  }

  .row-bg-gray:hover {
    border-radius: 4px;
    background: rgba(236, 236, 235, 1);
  }

  .tab-table {
    // box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 5px 0 rgba(0, 0, 0, .12);
    box-shadow: 0 3px 2px 5px rgba(0, 0, 0, 0.06),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;

    > div.md-card-content {
      padding: 13px 6px 15px 15px;
    }
  }

  .mktops-tab {
    width: 100%;
    // box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 0px 5px 0 rgba(0, 0, 0, .12);
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      1px 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 5px 0 rgba(0, 0, 0, 0.12);

    &.md-card.md-theme-default {
      height: 100%;
      // box-shadow: unset;

      .md-card-content {
        display: contents;

        > div {
          display: flex;
          padding-top: 15px;
          height: 50px;

          div {
            width: 15%;
            text-align: center;
            font-weight: bold;
            color: #727272;
            cursor: pointer;

            &.tab-active {
              border-bottom: 3px solid #3f51b5;
            }
          }
        }

        .tab-chip {
          padding-left: 7px;
          padding-right: 7px;
          border-radius: 35px;
          color: white;
          font-size: 12px;
          padding-top: 3px;
          padding-bottom: 3px;
          margin-left: 5px;

          &.-chipgray {
            background-color: #727272;
          }

          &.-primary {
            background-color: #3f51b5;
          }

          &.-warning {
            background-color: #f44336;
          }
        }
      }
    }
  }

  .md-card.mktops-control-box {
    width: 100%;
  }
}
</style>
